import { z } from 'zod';
import { SALES_ORDER_LINE_CONSTRAINTS } from './constraints.js';
// Upper bound stays well under the Decimal(28,9) column's overflow point.
export const salesOrderLineUnitPriceSchema = z
    .number()
    .min(0, `${SALES_ORDER_LINE_CONSTRAINTS.unitPrice.label} must be a non-negative number.`)
    .max(1_000_000_000, `${SALES_ORDER_LINE_CONSTRAINTS.unitPrice.label} must be 1,000,000,000 or less.`);
//# sourceMappingURL=item-unit-price.js.map